import { useAuthAxiosBaseUrl } from './useAuthAxiosBaseUrl';
import { useAuthAxiosDeleteOnSignOutEffect } from './useAuthAxiosDeleteOnSignOutEffect';
import { useAuthAxiosInterceptorEffect } from './useAuthAxiosInterceptorEffect';
/**
 * Hook for connecting Axios to MSAL.
 */
export const useAuthAxiosConfigEffect = (enabled) => {
    useAuthAxiosBaseUrl();
    useAuthAxiosInterceptorEffect(enabled);
    useAuthAxiosDeleteOnSignOutEffect();
};
